<template>
  <LicensePageTemplate :back-route="{ name: 'ProviderLicenseIndex' }" />
</template>

<script setup>
import LicensePageTemplate from '@/shared/components/licenses/LicensePageTemplate.vue';
</script>
